const find = require('lodash/fp/find');
const reject = require('lodash/fp/reject');
const flow = require('lodash/fp/flow');
const shuffle = require('lodash/fp/shuffle');
const concat = require('lodash/fp/concat');

const inject = [
  '$scope',
  '$stateParams',
  '$translate',
  'subscriptionOrchestrator',
  'toastService',
  'CancelReason',
  'reasons',
  '$state',
  '$document',
  'tracking'
];

function CancelSubscriptionControllerFactory(
  $scope,
  $stateParams,
  $translate,
  subscriptionOrchestrator,
  toastService,
  CancelReason,
  reasons,
  $state,
  $document,
  trackingService
) {
  class CancelSubscriptionController {
    constructor(_subscription, _reasons) {
      this.subscription = _subscription;
      this.reasons = _reasons;
      this.otherReasonCode = 1;

      this.userReason = new CancelReason();

      this.hasOther = angular.isDefined(find({ isOther: true }, this.reasons));
    }

    $onInit() {
      this.reasons = prepareReasons(this.reasons);
    }

    trackCancelReason(reason, eventName = 'og_msi_cancel_reason_select') {
      if (!reason.details) {
        return;
      }

      trackingService.trackEvent(eventName, {
        subscriptionId: this.subscription.publicId,
        cancelCode: reason.code,
        detail: reason.details,
        formPosition: this.reasons.findIndex(el => el.code === reason.code) + 1
      });
    }

    submit(reason) {
      this.submitting = subscriptionOrchestrator.cancel(this.subscription.publicId, `${reason.code}|${reason.details}`)
        .then(() => toastService.translate.success('TOAST_CANCEL_SUCCESS'))
        .then(() => this.trackCancelReason(reason, 'og_msi_cancel_form_submit'))
        .then(() => $scope.$close())
        .then(() => $state.go('root', {}, { reload: true }))
        .catch(() => toastService.translate.danger('TOAST_CANCEL_DANGER'));

      return this.submitting;
    }

    focusValidationErrorsSummary() {
      $document[0].querySelector('.og-modal-window #validation-summary').focus();
    }
  }

  return new CancelSubscriptionController($stateParams.subscription, reasons);
}

CancelSubscriptionControllerFactory.$inject = inject;

module.exports = CancelSubscriptionControllerFactory;

function prepareReasons(reasons) {
  const isOther = { isOther: true };
  const other = find(isOther, reasons);

  const result = flow(reject(isOther), shuffle)(reasons);

  if (other) {
    return concat(result, other);
  }

  return result;
}

module.exports.prepareReasons = prepareReasons;
